import React from 'react';

const PageHero = ({ title, subtitle, breadcrumb = null }) => {
  return (
    <section className="page-header-section">
      {/* グラデーションメッシュ背景 */}
      <div className="gradient-mesh">
        <div className="gradient-blob gradient-blob-1"></div>
        <div className="gradient-blob gradient-blob-2"></div>
        <div className="gradient-blob gradient-blob-3"></div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="header-content">
              {/* パンくずリスト（オプション） */}
              {breadcrumb && (
                <nav aria-label="breadcrumb" className="m-20px-b">
                  <ol className="breadcrumb justify-content-center">
                    <li className="breadcrumb-item">
                      <a href="/">ホーム</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {breadcrumb}
                    </li>
                  </ol>
                </nav>
              )}

              {/* タイトル */}
              <h1 className="display-4 font-weight-bold">
                {title}
              </h1>

              {/* サブタイトル */}
              {subtitle && (
                <p className="lead">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageHero;